// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input,
 TextField
} from "@mui/material";

// App Imports
import {changeStakeholderList} from "./stakeholderListSlice";
import {addStakeholderList, editStakeholderList} from "./StakeholderListClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import {getAllPlatforms} from "../Platform/PlatformClient";
import {getAllLicenses} from "../License/LicenseClient";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import {NumericFormat} from "react-number-format";


// Main Function
export default function StakeholderListDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorStakeholderListId = useSelector((state) => state.stakeholderListSlc.value.id);
    const selectorStakeholderListDrawerState = useSelector((state) => state.stakeholderListSlc.value.stakeholderListDrawerState);
    const selectorStakeholderListDrawerMode = useSelector((state) => state.stakeholderListSlc.value.stakeholderListDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, control, reset, handleSubmit} = useForm();


    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
         setSubmitting(true)
        console.log("here's my StakeholderList data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorStakeholderListDrawerMode==="Add"){
            addStakeholderList(data)
                .then(() => {
                    console.log("StakeholderList added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeStakeholderList({
                    id: null,
                    fileId: null,
                    recordId: null,
                    productId: null,
                    guild: null,
                    fsoId: null,
                    fsoTaxId: null,
                    fsoFirstName: null,
                    fsoLastName: null,
                    fsoSuffix: null,
                    contractedPartyId: null,
                    contractedPartyTaxId: null,
                    contractedPartyFirstName: null,
                    contractedPartyLastName: null,
                    contractedPartySuffix: null,
                    contractedPartyCompanyName: null,
                    payeeId: null,
                    payeeTaxId: null,
                    payeeFirstName: null,
                    payeeLastName: null,
                    payeeSuffix: null,
                    payeeCompanyName: null,
                    jobCode: null,
                    contractLength: null,
                    contractDate: null,
                    compensation: null,
                    pensionedCompensation: null,
                    scaleCompensation: null,
                    overtimeCompensation: null,
                    premiumOvertimeCompensation: null,
                    wardrobeCompensation: null,
                    allowances: null,
                    penalties: null,
                    workBeginDate: null,
                    daysWorked: null,
                    note1: null,
                    note2: null,
                    note3: null,
                    status: null,
                    createdOn: null,
                    createdBy: null,
                    lastModifiedOn: null,
                    lastModifiedBy: null,
                    taxingLocation: null,
                    additFringedCompensation: null,
                    advance: null,
                    guildEquivalent: null,
                    participant: null,
                    advance2: null,
                    guaranteedDays: null,
                    stakeholderListGridRefresh: true, stakeholderListDrawerState: false, stakeholderListDrawerMode: null}))
            })}
        if(selectorStakeholderListDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addStakeholderList(data)
                .then(() => {
                    console.log("StakeholderList cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeStakeholderList({id: null,
                    fileId: null,
                    recordId: null,
                    productId: null,
                    guild: null,
                    fsoId: null,
                    fsoTaxId: null,
                    fsoFirstName: null,
                    fsoLastName: null,
                    fsoSuffix: null,
                    contractedPartyId: null,
                    contractedPartyTaxId: null,
                    contractedPartyFirstName: null,
                    contractedPartyLastName: null,
                    contractedPartySuffix: null,
                    contractedPartyCompanyName: null,
                    payeeId: null,
                    payeeTaxId: null,
                    payeeFirstName: null,
                    payeeLastName: null,
                    payeeSuffix: null,
                    payeeCompanyName: null,
                    jobCode: null,
                    contractLength: null,
                    contractDate: null,
                    compensation: null,
                    pensionedCompensation: null,
                    scaleCompensation: null,
                    overtimeCompensation: null,
                    premiumOvertimeCompensation: null,
                    wardrobeCompensation: null,
                    allowances: null,
                    penalties: null,
                    workBeginDate: null,
                    daysWorked: null,
                    note1: null,
                    note2: null,
                    note3: null,
                    status: null,
                    createdOn: null,
                    createdBy: null,
                    lastModifiedOn: null,
                    lastModifiedBy: null,
                    taxingLocation: null,
                    additFringedCompensation: null,
                    advance: null,
                    guildEquivalent: null,
                    participant: null,
                    advance2: null,
                    guaranteedDays: null,
                    stakeholderListGridRefresh: true, stakeholderListDrawerState: false, stakeholderListDrawerMode: null}))
            })}
        if(selectorStakeholderListDrawerMode==="Edit"){
            console.log("This is the StakeholderList Id I am going to edit")
            console.log(selectorStakeholderListId)
            editStakeholderList(selectorStakeholderListId, data)
                .then(() => {
                    console.log("StakeholderList edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeStakeholderList({
                    stakeholderListGridRefresh: true, stakeholderListDrawerState: false, stakeholderListDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeStakeholderListDrawer() {
        dispatchData(changeStakeholderList({stakeholderListDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);


    const fetchPlatformsForDropdown = () =>
        getAllPlatforms()

            .then(data => {
                console.log("Platforms List")
                console.log(data);
                setPlatforms(data);

            })
    useEffect(() => {
        console.log("This is for the platforms dropdown...");
        fetchPlatformsForDropdown();
    }, []);


    const fetchLicensesForDropdown = () =>
        getAllLicenses()

            .then(data => {
                console.log("Licenses List")
                console.log(data);
                setLicenses(data);

            })
    useEffect(() => {
        console.log("This is for the licenses dropdown...");
        fetchLicensesForDropdown();
    }, []);

// *********************** END DROPDOWNS **************************

    const stakeholderList = useSelector((state) => state.stakeholderListSlc.value);

    useEffect(() => {

        reset({
            ...stakeholderList,
            contractDate: stakeholderList.contractDate
                ? dayjs(stakeholderList.contractDate)
                : null,

            workBeginDate: stakeholderList.workBeginDate
                ? dayjs(stakeholderList.workBeginDate)
                : null,

            advance: stakeholderList.advance,
            compensation: stakeholderList.compensation,
            pensionedCompensation: stakeholderList.pensionedCompensation,
            scaleCompensation: stakeholderList.scaleCompensation,
            overtimeCompensation: stakeholderList.overtimeCompensation,
            premiumOvertimeCompensation: stakeholderList.premiumOvertimeCompensation,
            wardrobeCompensation: stakeholderList.wardrobeCompensation,
            allowances: stakeholderList.allowances,
            penalties: stakeholderList.penalties,
            additFringedCompensation: stakeholderList.additFringedCompensation,



        });


    }, [stakeholderList, reset]);


    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [licenses, setLicenses] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);

    // ****************** BEGIN FORM ****************************

    function stakeholderListForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 1200, height: 800, pl: 5}}
                    role="presentation"
                >

                    <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeStakeholderListDrawer()}>Stakeholder List Form</h2>
                    <h4>{selectorStakeholderListDrawerMode} Mode</h4>
                    <br/>
                    <Input
                        style={{visibility: "hidden"}}
                        {...register('id', {required: true})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.stakeholderListSlc.value.id))}
                    />
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('fileId', {required: true})}
                            id="fileId" name="fileId" label="File ID" aria-describedby="fileId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.fileId)}
                            sx={{width:
                                200}}/>
                        <TextField
                            {...register('recordId', {required: true})}
                            id="recordId" name="recordId" label="Record ID" aria-describedby="recordId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.recordId)}
                            sx={{width: 100}}/>
                        <TextField
                            {...register('productId', {required: true})}
                            id="productId" name="productId" label="Product ID" aria-describedby="productId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.productId)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('guild', {required: true})}
                            id="guild" name="guild" label="Guild" aria-describedby="guild_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.guild)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <p>For Services Of</p>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('fsoId', {required: false})}
                            id="fsoId" name="fsoId" label="ID" aria-describedby="fsoId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.fsoId)}
                            sx={{width: 100}}/>
                        <TextField
                            {...register('fsoTaxId', {required: false})}
                            id="fsoTaxId" name="fsoTaxId" label="Tax ID" aria-describedby="fsoTaxId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.fsoTaxId)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('fsoFirstName', {required: false})}
                            id="fsoFirstName" name="fsoFirstName" label="First Name"
                            aria-describedby="fsoFirstName_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.fsoFirstName)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('fsoLastName', {required: false})}
                            id="fsoLastName" name="fsoLastName" label="Last Name" aria-describedby="fsoLastName_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.fsoLastName)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('fsoSuffix', {required: false})}
                            id="fsoSuffix" name="fsoSuffix" label="Suffix" aria-describedby="fsoSuffix_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.fsoSuffix)}
                            sx={{width: 100}}/>
                    </Stack>
                    <br/>
                    <p>Contracted Party</p>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('contractedPartyId', {required: false})}
                            id="contractedPartyId" name="contractedPartyId" label="ID"
                            aria-describedby="contractedPartyId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractedPartyId)}
                            sx={{width: 100}}/>
                        <TextField
                            {...register('contractedPartyTaxId', {required: false})}
                            id="contractedPartyTaxId" name="contractedPartyTaxId" label="Tax ID"
                            aria-describedby="contractedPartyTaxId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractedPartyTaxId)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('contractedPartyFirstName', {required: false})}
                            id="contractedPartyFirstName" name="contractedPartyFirstName"
                            label="First Name" aria-describedby="contractedPartyFirstName_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractedPartyFirstName)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('contractedPartyLastName', {required: false})}
                            id="contractedPartyLastName" name="contractedPartyLastName" label="Last Name"
                            aria-describedby="contractedPartyLastName_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractedPartyLastName)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('contractedPartySuffix', {required: false})}
                            id="contractedPartySuffix" name="contractedPartySuffix" label="Suffix"
                            aria-describedby="contractedPartySuffix_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractedPartySuffix)}
                            sx={{width: 100}}/>
                        <TextField
                            {...register('contractedPartyCompanyName', {required: false})}
                            id="contractedPartyCompanyName" name="contractedPartyCompanyName"
                            label="Company Name" aria-describedby="contractedPartyCompanyName"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractedPartyCompanyName)}
                            sx={{width: 300}}/>
                    </Stack>
                    <br/>
                    <p>Payee</p>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('payeeId', {required: false})}
                            id="payeeId" name="payeeId" label="ID"
                            aria-describedby="payeeId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.payeeId)}
                            sx={{width: 100}}/>
                        <TextField
                            {...register('payeeTaxId', {required: false})}
                            id="payeeTaxId" name="payeeTaxId" label="Tax ID"
                            aria-describedby="payeeTaxId_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.payeeTaxId)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('payeeFirstName', {required: false})}
                            id="payeeFirstName" name="payeeFirstName"
                            label="First Name" aria-describedby="payeeFirstName_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.payeeFirstName)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('payeeLastName', {required: false})}
                            id="payeeLastName" name="payeeLastName" label="Last Name"
                            aria-describedby="payeeLastName_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.payeeLastName)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('payeeSuffix', {required: false})}
                            id="payeeSuffix" name="payeeSuffix" label="Suffix"
                            aria-describedby="payeeSuffix_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.payeeSuffix)}
                            sx={{width: 100}}/>
                        <TextField
                            {...register('payeeCompanyName', {required: false})}
                            id="payeeCompanyName" name="payeeCompanyName"
                            label="Company Name" aria-describedby="payeeCompanyName"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.payeeCompanyName)}
                            sx={{width: 300}}/>
                    </Stack>
                    <br/>
                    <p>Contract</p>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('jobCode', {required: false})}
                            id="jobCode" name="jobCode" label="Job Code"
                            aria-describedby="jobCode_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.jobCode)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('contractLength', {required: false})}
                            id="contractLength" name="contractLength" label="Contract Length"
                            aria-describedby="contractLength_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractLength)}
                            sx={{width: 150}}/>
                        {/*<TextField*/}
                        {/*    {...register('contractDate', {required: false})}*/}
                        {/*    id="contractDate" name="contractDate"*/}
                        {/*    label="Contract Date" aria-describedby="contractDate_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractDate)}*/}
                        {/*    sx={{width: 150}}/>*/}
                        <FormDatePicker
                            name="contractDate"
                            label="Contract Date"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                        <TextField
                            {...register('guildEquivalent', {required: false})}
                            id="guildEquivalent" name="guildEquivalent" label="Guild Equivalent"
                            aria-describedby="guildEquivalent_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.guildEquivalent)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('participant', {required: false})}
                            id="participant" name="participant" label="Participant"
                            aria-describedby="participant_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.participant)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('guaranteedDays', {required: false})}
                            id="guaranteedDays" name="guaranteedDays" label="Guaranteed Days"
                            aria-describedby="guaranteedDays_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.guaranteedDays)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('advance', {required: false})}
                            id="advance" name="advance" label="Advance"
                            aria-describedby="advance_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.advance)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('advance2', {required: false})}
                            id="advance2" name="advance2"
                            label="Advance 2" aria-describedby="advance2_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.advance2)}
                            sx={{width: 150}}/>
                    </Stack>
                    <br/>
                    <p>Work</p>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('workBeginDate', {required: false})}*/}
                        {/*    id="workBeginDate" name="workBeginDate" label="Work Begin Date"*/}
                        {/*    aria-describedby="workBeginDate_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.workBeginDate)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <FormDatePicker
                            name="workBeginDate"
                            label="Work Begin Date"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                        <TextField
                            {...register('daysWorked', {required: false})}
                            id="daysWorked" name="daysWorked" label="Days Worked"
                            aria-describedby="daysWorked_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.daysWorked)}
                            sx={{width: 150}}/>
                        <TextField
                            {...register('taxingLocation', {required: false})}
                            id="taxingLocation" name="taxingLocation" label="Taxing Location"
                            aria-describedby="taxingLocation_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.taxingLocation)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <p>Pay</p>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('compensation', {required: false})}*/}
                        {/*    id="compensation" name="compensation" label="Initial"*/}
                        {/*    aria-describedby="compensation_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.compensation)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="compensation"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Initial"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        {/*<TextField*/}
                        {/*    {...register('pensionedCompensation', {required: false})}*/}
                        {/*    id="pensionedCompensation" name="pensionedCompensation" label="Pensioned"*/}
                        {/*    aria-describedby="pensionedCompensation_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.pensionedCompensation)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="pensionedCompensation"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Pensioned"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        {/*<TextField*/}
                        {/*    {...register('scaleCompensation', {required: false})}*/}
                        {/*    id="scaleCompensation" name="scaleCompensation" label="Scale"*/}
                        {/*    aria-describedby="scaleCompensation_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.scaleCompensation)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="scaleCompensation"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Scale"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        {/*<TextField*/}
                        {/*    {...register('overtimeCompensation', {required: false})}*/}
                        {/*    id="overtimeCompensation" name="overtimeCompensation"*/}
                        {/*    label="Overtime" aria-describedby="overtimeCompensation_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.overtimeCompensation)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="overtimeCompensation"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Overtime"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        {/*<TextField*/}
                        {/*    {...register('premiumOvertimeCompensation', {required: false})}*/}
                        {/*    id="premiumOvertimeCompensation" name="premiumOvertimeCompensation"*/}
                        {/*    label="Premium Overtime" aria-describedby="premiumOvertimeCompensation_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.premiumOvertimeCompensation)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="premiumOvertimeCompensation"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Premium Overtime"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                    </Stack>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('wardrobeCompensation', {required: false})}*/}
                        {/*    id="wardrobeCompensation" name="wardrobeCompensation" label="Wardrobe"*/}
                        {/*    aria-describedby="wardrobeCompensation_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.wardrobeCompensation)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="wardrobeCompensation"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Wardrobe"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        {/*<TextField*/}
                        {/*    {...register('allowances', {required: false})}*/}
                        {/*    id="allowances" name="allowances" label="Allowances"*/}
                        {/*    aria-describedby="allowances_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.allowances)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="allowances"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Allowances"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        {/*<TextField*/}
                        {/*    {...register('penalties', {required: false})}*/}
                        {/*    id="penalties" name="penalties"*/}
                        {/*    label="Penalties" aria-describedby="penalties_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.penalties)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="penalties"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Penalties"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        {/*<TextField*/}
                        {/*    {...register('additFringedCompensation', {required: false})}*/}
                        {/*    id="additFringedCompensation" name="additFringedCompensation"*/}
                        {/*    label="Additional Fringed"*/}
                        {/*    aria-describedby="additFringedCompensation_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.stakeholderListSlc.value.additFringedCompensation)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="additFringedCompensation"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Additional Fringed"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                    </Stack>
                    <br/>
                    <p>Misc</p>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('note1', {required: false})}
                            id="note1" name="note1" label="Note 1"
                            aria-describedby="note1_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.note1)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('note2', {required: false})}
                            id="note2" name="note2" label="Note 2"
                            aria-describedby="note2_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.note2)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('note3', {required: false})}
                            id="note3" name="note3" label="Note 3"
                            aria-describedby="note3_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.note3)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status"
                            aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>

                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeStakeholderListDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
            </div>
        )
    }

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorStakeholderListDrawerState}
                onClose={closeStakeholderListDrawer}
            >
                {stakeholderListForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
